import React from 'react';
import {NavLink} from 'react-router-dom';
import Icons from '../Icons';

let MenuRight = (props) => {
  let {icons, openMod, funct, screen} = props;
  const rightA = (key, f, s, i) => {
    return (
      <a
        key={key} 
        className={"MenuRight Icon " + key}
        onClick={() => f(s)}>
        <Icons name={i} />
      </a>
    )
  }
  const rightNavL = (key, link, f=null) => {
    return (
      <NavLink 
        to={link}
        key={key} 
        className={"MenuRight Icon " + key} 
        onClick={f ? () => f() : null}
      >
        <Icons name={key} />
      </NavLink>
    )
  }
  return (
    <div id="MenuRight">{
    icons.map((key) => {
      switch(key){
        case "addNew":
          return rightNavL(key, "/home/tableros/add");
        case "addCard":
          return rightNavL(key, "/home/tableros", funct);
        case "close":
          return rightNavL(key, "/home/tableros");
        case "create":
          return rightA(key, openMod, screen, "addNew");
        case "key":
          return rightA(key, openMod, "UsrCnfPass", "key");
        case "trash":
          return rightA(key, openMod, "UsrCnfDel", "trash");
        case "addTab":
          return rightA(key, openMod, screen, "addNew");
        case "trashtab":
          return rightA(key, openMod, "TabCnfDel", "trash");
        case "addVis":
          return rightA(key, openMod, "PointCnf", "addNew");
        default:
          return <div key={key} ></div>
      }
    })}</div>
  )
}

export default MenuRight;


// WEBPACK FOOTER //
// ./src/Containers/Nav/MenuRight.js